import React from 'react';

const LockIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="5.92499" cy="16.275" r="2.475" stroke="stroke" strokeWidth="1.8" />
    <circle cx="18.075" cy="16.275" r="2.475" stroke="stroke" strokeWidth="1.8" />
    <path
      d="M20.775 15.6V15.6C21.8934 15.6 22.8 14.6934 22.8 13.575V13.1297C22.8 11.8624 21.8146 10.8134 20.5497 10.7344L2.47487 9.6047C1.78403 9.56153 1.20001 10.1102 1.20001 10.8024V13.2C1.20001 14.5255 2.27453 15.6 3.60001 15.6H3.90001"
      stroke="stroke"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.90002 8.85005L5.88754 5.86877C6.33266 5.20109 7.08202 4.80005 7.88447 4.80005H12.936C13.6281 4.80005 14.2864 5.0988 14.7422 5.61964L18.75 10.2"
      stroke="stroke"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.625 15.6001H15.375" stroke="stroke" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default LockIcon;
